import React, { Component } from 'react';
import { sortBasedOnList } from '../utils';

export type Table11aData = { [key: string]: Table11aRow };
interface ITable11aProps {
  data: Table11aData
}

export interface Table11aRow {
  fatal: number;
  injuryA: number;
  injuryB: number;
  injuryC: number;
  pdo: number;
  total: number;
}

interface ITable11aState {
}

const sortOrder = [
  "No Contributing Action",
  "Disregarded Red Light",
  "Disregarded Stop Sign",
  "Disregarded Road Markings",
  "Disregarded Traffic Sign",
  "Failed to Keep in Proper Lane",
  "Failed to Yield Right-of-Way",
  "Followed too Closely",
  "Improper Backing",
  "Improper Passing",
  "Improper Turn",
  "Operated Motor Vehicle in Inattentive, Careless, Negligent or Erratic Manner",
  "Operated Motor Vehicle in Reckless or Aggressive Manner",
  "Over-Correcting/Over-Steering",
  "Ran Off Roadway",
  "Swerved or Avoided Due to Wind, Slippery Surface, Motor Vehicle, Object, Non-Motorist in Roadway, etc.",
  "Wrong Side or Wrong Way",
  "Other Contributing Action",
  "Unknown",
  "Not Stated",
];

export default class Table11aSummary extends Component<ITable11aProps, ITable11aState> {
  constructor(props: ITable11aProps) {
    super(props);
    this.state = {
    }
  }

  componentDidMount = function () {
  }

  render() {
    return (
      this.props.data ?
        <table className="ss-table summaryTable1">
          <colgroup>
            <col style={{ width: 800 }} />
          </colgroup>
          <thead>
            <tr>
              <th rowSpan={2} className="border-right-bold">
                <div className="ss-table-header">
                  <span className="header-number">11a</span>
                  <span className="header-text">
                    <div>DRIVER ACTIONS</div>
                    <small>Up to 4 actions per driver</small>
                  </span>
                </div>
              </th>
              <th rowSpan={2}>TOTAL</th>
              <th rowSpan={2}>FATAL</th>
              <th colSpan={3}>INJURY</th>
              <th rowSpan={2}>PDO **</th>
            </tr>
            <tr>
              <th>A*</th>
              <th>B*</th>
              <th>C*</th>
            </tr>
          </thead>
          <tbody>
            {sortBasedOnList(this.props.data, sortOrder).map((key) =>
              <tr key={key}>
                <td className="border-right-bold">{key}</td>
                <td className="numberTotals">{this.props.data[key].total}</td>
                <td className="numberTotals">{this.props.data[key].fatal}</td>
                <td className="numberTotals">{this.props.data[key].injuryA}</td>
                <td className="numberTotals">{this.props.data[key].injuryB}</td>
                <td className="numberTotals">{this.props.data[key].injuryC}</td>
                <td className="numberTotals">{this.props.data[key].pdo}</td>
              </tr>
            )}
          </tbody>
        </table>
        : <p>Loading...</p>
    );
  }
}
